// @flow
import React from 'react';
import { useFormikContext } from 'formik';
import { getDimensionFieldPathForEstimateCC } from '@components/committed-capacity/utils';

import { ESTIMATE_COMMITTED_CAPACITY } from '../enums';
import { TextField } from '../../../formik-utils/FormFields';
import { TEXT_NUMBER_INPUT_TYPE } from '../../../formik-utils/consts';
import { IS_ROW_OPENED_FOR_EDITING } from '../../../constants';
import { useIsRowInputDisabledForEstimateCC } from '../../../custom-hooks/useIsRowInputDisabledForEstimateCC';

export const QuantityContainerForEstimateCC = ({
  dimensionRow,
  metricRow,
  configuredMetrics,
  metricIndex,
  dimensionIndex,
}) => {
  const { setFieldValue } = useFormikContext();

  const shouldQuantityBeDisabled = useIsRowInputDisabledForEstimateCC({
    dimensionRow,
    metricName: metricRow.metricName,
    configuredMetrics,
  });

  const quantityPath = getDimensionFieldPathForEstimateCC(
    metricIndex,
    dimensionIndex,
    ESTIMATE_COMMITTED_CAPACITY.QUANTITY_BACKEND_FIELD_NAME
  );
  const inProgressFieldName = getDimensionFieldPathForEstimateCC(
    metricIndex,
    dimensionIndex,
    IS_ROW_OPENED_FOR_EDITING
  );

  return (
    <TextField
      addLabel={false}
      disableOnFormErrors={false}
      disabled={shouldQuantityBeDisabled}
      fieldDisplayName={ESTIMATE_COMMITTED_CAPACITY.QUANTITY_DISPLAY_NAME}
      fieldName={quantityPath}
      onChange={async () => {
        await setFieldValue(inProgressFieldName, true);
      }}
      placeholder={ESTIMATE_COMMITTED_CAPACITY.QUANTITY_DISPLAY_NAME}
      type={TEXT_NUMBER_INPUT_TYPE}
    />
  );
};
